import { render } from "./Balance.vue?vue&type=template&id=a9ef2604"
import script from "./Balance.vue?vue&type=script&lang=js"
export * from "./Balance.vue?vue&type=script&lang=js"

import "./Balance.vue?vue&type=style&index=0&id=a9ef2604&lang=scss"

import exportComponent from "D:\\work\\beam\\Project\\DAPPS\\beam-dapps\\nft_gallery_fe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__